import type { LowEntropyBrowserHints } from '../browserFeatures.types';

/**
 * See https://caniuse.com/avif
 *
 * NOTE: We don't want to mandate high entropy hints here, so no support for Safari 16.
 */
export function supportsAvif(hints: LowEntropyBrowserHints): boolean {
  // Egde. (Not supported currently as of 2023-08). Check before Chromium check.
  // TODO: Check back in later.
  const isEdge = hints.browsers.find(({ brand }) => brand === 'Edge');
  if (isEdge) return false;

  // Chrome, Android Internet, Samsung Internet
  const isChrome85 = hints.browsers.find(
    ({ brand, majorVersion }) => (brand === 'Chrome' || brand === 'Chromium') && majorVersion >= 85
  );
  if (isChrome85) return true;

  // Firefox
  // Technically there's limited support in 93-112, but we skip it here.
  const isFirefox113 = hints.browsers.find(
    ({ brand, majorVersion }) => brand === 'Firefox' && majorVersion >= 113
  );
  if (isFirefox113) return true;

  // Opera
  // Opera Mini isn't supported.
  const isOperaMini = hints.browsers.find(({ brand }) => brand === 'Opera Mini');
  const isOpera71 = hints.browsers.find(
    ({ brand, majorVersion }) => brand === 'Opera' && majorVersion >= 71
  );
  if (isOpera71 && !isOperaMini) return true;

  // Safari
  // NOTE: We ignore high-entropy lookups for 16.1-16.3 on MacOS13+ and 16.4+
  const isSafari17 = hints.browsers.find(
    ({ brand, majorVersion }) => brand === 'Safari' && majorVersion >= 17
  );
  if (isSafari17) return true;

  // Others
  return false;
}
